import _ from 'lodash';
import {combineReducers} from 'redux-immutable';

import {reducer as usersReducer, initialState as usersInitialState} from '../users';
import treeReducer from '../tree/reducer';


export const initialState = {
    users: usersInitialState,
    typesTree: {
        elementId: window.uuidv4(),
        staticItems: _.mapValues(
            _.mapKeys(Array(3), (__, index) => Number(index) + 1),
            (__, index) => ({id: index, label: window.pgettext('message', 'SMSType-' + index)}),
        ),
    },
};
export const reducer = combineReducers({
    users: usersReducer,
    typesTree: treeReducer,
});
export {default as component} from './component';
